import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { isFormControlRequired } from '@digilize/shared/utils/helpers/src';

@Component({
  selector: 'lib-datepicker-with-hours',
  templateUrl: './datepicker-with-hours.component.html',
  styleUrls: ['./datepicker-with-hours.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class DatepickerWithHoursComponent {
  @Input() control: UntypedFormControl;
  @Input() label: string;
  @Input() disabled: boolean;
  // Five keeps the product's own availability date as it was. A price row passes 1: two prices
  // may not start in the same second, so a minute is the smallest gap that has to be enterable
  // (PAUL-3469).
  @Input() stepMinute = 5;
  isFormControlRequired(): boolean {
    return isFormControlRequired(this.control);
  }
}
